import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'filterByStatus',
})
export class FilterByStatusPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;

    searchText = searchText.toLowerCase();
    return items.filter((it) => {
      return it['lastTaskStatus']?.statusId.includes(searchText);
    });
  }
}
